<template>
    <div
        class="show-content"
        v-if="dataTableservices != null && dataTableservices.promotion != null"
    >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-12">
                    <p
                        class="text-content"
                        v-html="dataTableservices.promotion.title"
                    ></p>
                    <p
                        class="text-sub"
                        v-html="dataTableservices.promotion.highlight"
                    ></p>
                    <p
                        class="text-detail text-pro"
                        v-html="dataTableservices.promotion.description"
                    ></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        dataTableservices: {
            type: Object,
            default: null
        }
    },
    methods: {
        //You can use !! (Double Negation). Its safer and it will check both null and undefined.
        chkValueError(value) {
            if (!!value) {
                value = "";
            }
            return value;
        }
    },
    computed: {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// resources/js/components/service/Promotion.vue